import { render, staticRenderFns } from "./DashboardRivers.vue?vue&type=template&id=f68d7a4c&"
import script from "./DashboardRivers.vue?vue&type=script&lang=js&"
export * from "./DashboardRivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports